module.exports = __webpack_public_path__ + "static/media/banner_cricketx.0430d2be.png";